import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS,
  beAutomatioApiGetConditionsdescription,
  beAutomationApiCreateWorkflowDetails,
  beAutomationApiGetWorkflowDetails,
  beAutomationApiGetWorkflowsList,
  beAutomationApiSetEnableWorkflow,
  beAutomationApiUpdateWorkflowDetails
} from 'Api/beAutomationApi'
import { beEmailCheckupGetAllowedProtocols } from 'Api/beEmailCheckupApi'
import {
  beEmailMessageGetMessageLazyDetails,
  beEmailMessageGetMessageLinks
} from 'Api/beEmailMessageApi'
import {
  beFiltersGetFilter,
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters,
  getAllAvailableFilterTypes
} from 'Api/beFiltersApi'
import {
  beListAddNewTag,
  beListApiGetAllTags,
  beListGetList,
  beListGetStatusOfWelcomeMessage
} from 'Api/beListApi'
import {
  beMessApiCopyMessage,
  beMessApiGetAllMessages,
  beMessApiGetEntitiesThatUseMessage
} from 'Api/beMessApi'
import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'
import {
  GROUPS_SEARCH_TYPE_CONTAINS,
  beRecipientAddGroup,
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetListOfGroupDetails
} from 'Api/beRecipientApi'

import {
  beSmsMessageCopyMessage,
  beSmsMessageGetAllMessages,
  beSmsMessageGetEntitiesThatUseMessage,
  beSmsMessageGetSMSDetails
} from 'Api/beSmsMessageApi'

import {
  beSmsServicesCountMessageClicks,
  beSmsServicesCountMessageDeliveries,
  beSmsServicesCountMessageSent
} from 'Api/beSmsServicesApi'
import { statisticsGetMessageTotalCounters } from 'Api/statisticsApi'

import {
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  MESSAGE_TYPE_CONFIRMATION,
  MESSAGE_TYPE_CONTENTSCAMPAIGN,
  //
  MESSAGE_TYPE_GENERIC,
  MESSAGE_TYPE_WELCOME,
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE,
  SERVICE_TYPE_CONSOLE,
  //
  WORKFLOW_CONDITION_IS_TODAY,
  WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
  WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW,
  //
  WORKFLOW_FIELD_TYPE_DATETIME,
  WORKFLOW_START_TYPE_ACTIVITY,
  //
  WORKFLOW_START_TYPE_EVENT,
  WORKFLOW_START_TYPE_GROUP,
  WORKFLOW_START_TYPE_SUBSCRIBER_FIELD,
  WORKFLOW_START_TYPE_SUBSCRIPTION_DATE,
  //
  WORKFLOW_STEP_VALUE_TYPE_DAYS,
  //
  WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT
} from 'Constants'
import {
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  WORKFLOW_START_TYPE_FILTERS
} from 'Constants/index'
import getIntl from 'Helpers/intl'
import {
  STORE_KEY_ID_LIST,
  STORE_KEY_LIST,
  STORE_KEY_LOGIN_TYPE,
  evalCondition,
  storeGet
} from 'mailup-react-helpers'

import {
  WORKFLOWS_START_TYPE,
  defaultWorkflow
} from 'Pages/Workflow/recoil/state/data'

const stepEmailEmpty = {
  IdMessage: 0,
  MessageType: WORKFLOW_MESSAGE_TYPE_EMAIL,
  Value: 0,
  ValueType: 0,
  WaitType: 0,
  StepType: 'SendEmail'
}

const stepWait15 = {
  IdMessage: -1,
  MessageType: 0,
  Value: 15,
  ValueType: WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WaitType: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
  StepType: 'Wait'
}

const stepWait12 = {
  IdMessage: -1,
  MessageType: 0,
  Value: 12,
  ValueType: WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WaitType: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
  StepType: 'Wait'
}

const stepWait21 = {
  IdMessage: -1,
  MessageType: 0,
  Value: 21,
  ValueType: WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WaitType: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
  StepType: 'Wait'
}

const stepWait3 = {
  IdMessage: -1,
  MessageType: 0,
  Value: 3,
  ValueType: WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WaitType: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
  StepType: 'Wait'
}

const stepUnsubscriptionSetPending = {
  IdMessage: -1,
  MessageType: -1,
  EmailStatusCondition: 'OptIn',
  EmailStatus: 'Pending',
  StepType: 'ChangeStatus'
}

const stepUnsubscriptionSendConfirmation = {
  IdMessage: 0,
  MessageType: WORKFLOW_MESSAGE_TYPE_EMAIL,
  Value: 0,
  ValueType: 0,
  WaitType: 0,
  StepType: 'SendEmail'
}

const stepUnsubscriptionWait = {
  IdMessage: -1,
  MessageType: 0,
  Value: 30,
  ValueType: WORKFLOW_STEP_VALUE_TYPE_DAYS,
  WaitType: WORKFLOW_STEP_WAIT_TYPE_AFTER_EMAIL_SENT,
  StepType: 'Wait'
}

export async function getWorkflowDetails(idWorkflow) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { TimeZoneCode: listTZC } = storeGet(STORE_KEY_LIST)
  const [
    pecPlusConfig,
    { SenderName, SenderEmail, SenderReplyTo, BouncedEmail },
    { FromName, FromEmail, ReplyTo, TimeZoneCode, Step, Tags, ...details }
  ] = await Promise.all([
    bePecPlusGetPecPlusConfig(idList),
    beListGetList(idList),
    idWorkflow
      ? beAutomationApiGetWorkflowDetails(idWorkflow)
      : Promise.resolve({})
  ])

  const isPecPlus = pecPlusConfig && pecPlusConfig.Status

  const ListReplyTo = SenderReplyTo || BouncedEmail

  return {
    ...details,
    isPecPlus,
    FromName: idWorkflow ? FromName : SenderName,
    FromEmail: isPecPlus || !idWorkflow ? SenderEmail : FromEmail,
    ReplyTo: isPecPlus || !idWorkflow ? ListReplyTo : ReplyTo,
    TimeZoneCode: idWorkflow ? TimeZoneCode : listTZC,
    Tags: Tags || [],
    Step: Step || []
  }
}

export async function getStatusOfWelcomeMessage() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beListGetStatusOfWelcomeMessage(idList)
  return result
}

export async function getWorkflowsList(params, bodyParams) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = await beAutomationApiGetWorkflowsList(
    idList,
    params,
    bodyParams
  )
  return result
}

export async function fetchDynamicFields() {
  const result = await beRecipientGetDynamicFieldsDefinition()

  return {
    dynamicFields: result.map(({ Id, Description }) => ({
      value: Id,
      label: `${Id} - ${Description}`
    }))
  }
}

export async function fetchFilters(filterType) {
  const filterTypes = filterType ? [filterType] : getAllAvailableFilterTypes()
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items: filters } = await beFiltersGetListOfFilters(idList, {
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false,
    types: filterTypes
  })

  //
  return filters.map(({ Id, Name, Category }) => ({
    value: Id,
    label: `${Id} - ${Name}`,
    category: Category
  }))
}

export async function fetchFilterCategories() {
  const { Items } = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1
  })

  return [
    {
      id: 0,
      label: getIntl().formatMessage({ id: 'Load.Filters.NoCategory' })
    },
    ...Items.map(({ Id, Name }) => ({ id: Id, label: Name }))
  ]
}

export async function fetchProfileFilters() {
  const [filters, categories] = await Promise.all([
    fetchFilters('Anagraphic'),
    fetchFilterCategories()
  ])

  const tmp = categories
    .map(({ id, label }) => ({
      id,
      label,
      values: filters
        .filter(({ category }) => category === id)
        .map(({ value }) => value)
    }))
    .filter(({ values }) => Array.isArray(values) && values.length > 0)

  return {
    profileFilters: filters,
    profileFiltersCategories: tmp
  }
}

export async function loadGroups() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    pageSize: 0,
    pageNumber: 1
  })
  return {
    groups: [
      {
        value: 0,
        label: getIntl().formatMessage({ id: 'Load.Filters.NoGroupOption' })
      }
    ].concat(
      Items.map(({ Id, Name }) => ({
        value: Id,
        label: `${Id} - ${Name}`
      }))
    )
  }
}

export async function fetchActivityFilters() {
  const [filters, categories] = await Promise.all([
    fetchFilters('Activity'),
    fetchFilterCategories()
  ])

  const tmp = categories
    .map(({ id, label }) => ({
      id,
      label,
      values: filters
        .filter(({ category }) => category === id)
        .map(({ value }) => value)
    }))
    .filter(({ values }) => Array.isArray(values) && values.length > 0)

  return {
    activityFilters: filters,
    activityFiltersCategories: tmp
  }
}

export const fetchUnsubscriptionCampaignFilters = async () => {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const [{ Items }, categories] = await Promise.all([
    beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden,
      types: getAllAvailableFilterTypes()
    }),
    fetchFilterCategories()
  ])

  const filters = Items.sort((a, b) =>
    a.Name.toLowerCase().localeCompare(b.Name.toLowerCase())
  ).map(({ Id, Name, Category }) => ({
    value: Id,
    label: `${Id} - ${Name}`,
    category: Category
  }))

  const tmp = categories
    .map(({ id, label }) => ({
      id,
      label,
      values: filters
        .filter(({ category }) => category === id)
        .map(({ value }) => value)
    }))
    .filter(({ values }) => Array.isArray(values) && values.length > 0)

  return {
    startingFilters: filters,
    startingFiltersCategories: tmp
  }
}

export async function fetchEmailMessages() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beMessApiGetAllMessages(
    idList,
    `((MessageType == ${MESSAGE_TYPE_GENERIC}) || (MessageType == ${MESSAGE_TYPE_WELCOME}) || (MessageType == ${MESSAGE_TYPE_CONFIRMATION}) || (MessageType == ${MESSAGE_TYPE_CONTENTSCAMPAIGN})) && (ServiceType == ${SERVICE_TYPE_CONSOLE})`,
    '',
    1,
    0
  )

  return {
    emailMessages: Items.map(({ Id, Subject, MessageType }) => ({
      value: Id,
      label: `${Id} - ${Subject}`,
      MessageType
    }))
  }
}

export async function fetchSMSMessages() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beSmsMessageGetAllMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: 0
    },
    {
      Subject: '',
      Tags: []
    }
  )

  return {
    smsMessages: Items.map(({ Id, Subject }) => ({
      value: Id,
      label: `${Id} - ${Subject}`
    }))
  }
}

export async function fetchTags() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beListApiGetAllTags(idList)
  return {
    tags: Items.map(({ Id: value, Name: label }) => ({ value, label }))
  }
}

export async function fetchAllowedProtocols() {
  const result = await beEmailCheckupGetAllowedProtocols()
  return { allowedProtocols: result.map(({ Name }) => Name) }
}

export async function addNewTag(pTagName) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Id: value, Name: label } = await beListAddNewTag(idList, pTagName)
  return { value, label }
}

export const loadDataByStartType = (type) => {
  switch (type) {
    case WORKFLOW_START_TYPE_EVENT:
      return [fetchDynamicFields()]
    case WORKFLOW_START_TYPE_SUBSCRIPTION_DATE:
      return []
    case WORKFLOW_START_TYPE_SUBSCRIBER_FIELD:
      return [fetchDynamicFields(), fetchProfileFilters()]
    case WORKFLOW_START_TYPE_GROUP:
      return [loadGroups()]
    case WORKFLOW_START_TYPE_ACTIVITY:
      return [
        fetchActivityFilters(),
        fetchEmailMessages(),
        fetchSMSMessages(),
        fetchAllowedProtocols()
      ]
    case WORKFLOW_START_TYPE_FILTERS:
      return [fetchUnsubscriptionCampaignFilters()]
    default:
      return []
  }
}

export async function setupStep2(type) {
  const startType = WORKFLOWS_START_TYPE[type]

  const commonData = (
    await Promise.all([fetchTags(), ...loadDataByStartType(startType)])
  ).reduce((acc, cv) => ({ ...acc, ...cv }), {})

  return {
    commonData,
    startType
  }
}

export async function addGroup(name, notes, test) {
  const IdList = storeGet(STORE_KEY_ID_LIST)
  const payload = {
    IdList,
    Name: name,
    Notes: notes,
    Deleteable: true,
    Type: test ? 'Test' : 'Normal'
  }
  const newGroup = await beRecipientAddGroup(payload)
  return newGroup
}

export const linksSort = (a, b) => (a > b ? 1 : a < b ? -1 : 0)

export async function fetchMessageLinks(idMessage, protocols) {
  const { Items } = await beEmailMessageGetMessageLinks(idMessage)

  const urls = Items.filter(({ Protocol }) => protocols.includes(Protocol)).map(
    ({ Url }) => Url
  )
  const uniqueSortedUrls = Array.from(new Set(urls)).sort(linksSort)

  return uniqueSortedUrls
}

export const getStep2Defaults = (type, oldType) => {
  if (oldType === type) return {}

  switch (type) {
    case OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE:
    case OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE:
      return {
        ...defaultWorkflow,
        ActivityValue: 0,
        Step: [{ ...stepEmailEmpty }]
      }

    case OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE:
      return {
        ...defaultWorkflow,
        IdFieldFilter: WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
        FieldValue: 7,
        Step: [{ ...stepEmailEmpty }]
      }

    case OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE:
      return {
        ...defaultWorkflow,
        IdFieldFilter: WORKFLOW_CONDITION_MINUS_X_DAYS_IS_TODAY,
        FieldValue: 30,
        Step: [
          { ...stepEmailEmpty },
          { ...stepWait15 },
          { ...stepEmailEmpty },
          { ...stepWait12 },
          { ...stepEmailEmpty }
        ]
      }

    case OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE:
      return {
        ...defaultWorkflow,
        IdFieldFilter: WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW,
        FieldType: WORKFLOW_FIELD_TYPE_DATETIME,
        FieldValue: 3,
        Step: [{ ...stepEmailEmpty }, { ...stepWait21 }, { ...stepEmailEmpty }]
      }

    case OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE:
      return {
        ...defaultWorkflow,
        ActivityValue: 0,
        Step: [{ ...stepEmailEmpty }, { ...stepWait3 }, { ...stepEmailEmpty }]
      }

    case OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE:
      return {
        ...defaultWorkflow,
        IdFieldFilter: WORKFLOW_CONDITION_IS_TODAY,
        FieldValue: 0,
        Step: []
      }

    case OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE:
      return {
        ...defaultWorkflow,
        ActivityValue: 0,
        Step: []
      }

    case OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE:
      return {
        ...defaultWorkflow,
        Action: true,
        Step: []
      }

    case OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE:
      return {
        ...defaultWorkflow,
        Action: true,
        Step: []
      }

    case OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE:
      return {
        ...defaultWorkflow,
        IdFilter: 0,
        Action: true,
        ActivityValue: 0,
        Step: []
      }

    case OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE:
      return {
        ...defaultWorkflow,
        IdsFilter: [],
        RecipientLimit: 0,
        LastSendingPeriod: undefined,
        EndEmailStatusCondition: 'Pending',
        EndEmailStatus: 'OptOut',
        StartHour: '2000-01-01T00:00:00Z',
        BlackoutStartHour: null,
        BlackoutEndHour: null,
        Step: [
          { ...stepUnsubscriptionSetPending },
          { ...stepUnsubscriptionSendConfirmation },
          { ...stepUnsubscriptionWait }
        ]
      }
    default:
      return defaultWorkflow
  }
}

export async function updateWorkflow(idWorkflow, data) {
  const cleanData = {
    ...data,
    ActivityValue: +data.ActivityValue,
    FieldValue: data.FieldValue.toString(),

    Step: data.Step.map(
      ({
        Id,
        IdMessage,
        WaitType,
        Value,
        ValueType,
        MessageType,
        StepType,
        EmailStatusCondition,
        EmailStatus
      }) => ({
        Id: Id || 0,
        IdMessage,
        WaitType,
        Value: parseInt(Value),
        ValueType,
        MessageType,
        StepType,
        EmailStatusCondition,
        EmailStatus
      })
    ).filter(({ StepType }, index) => {
      return !(index === 0 && StepType === 'Wait') //  skip first step when is wait type
      /*
      if (index === 0 && IdMessage === -1) {
        return false
      }
      return true
      */
    })
  }

  return await beAutomationApiUpdateWorkflowDetails(idWorkflow, cleanData)
}

export async function createWorkflow(data) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const cleanData = {
    ...data,
    ActivityValue: +data.ActivityValue,
    FieldValue: data.FieldValue.toString(),
    IdList: idList,
    Step: data.Step.map(
      ({
        Id,
        IdMessage,
        WaitType,
        Value,
        ValueType,
        MessageType,
        StepType,
        EmailStatusCondition,
        EmailStatus
      }) => ({
        Id: Id || 0,
        IdMessage,
        WaitType,
        Value: parseInt(Value),
        ValueType,
        MessageType,
        StepType,
        EmailStatusCondition,
        EmailStatus
      })
    )
  }
  return await beAutomationApiCreateWorkflowDetails(cleanData)
}

export async function setEnableWorkflow(id, enable) {
  const result = await beAutomationApiSetEnableWorkflow(id, { Enable: enable })
  return result
}

export async function setupStep3(idWorkflow, steps) {
  const emailCalls = steps
    .filter(
      ({ IdMessage, MessageType }) =>
        IdMessage > 0 && MessageType === WORKFLOW_MESSAGE_TYPE_EMAIL
    )
    .map(({ IdMessage }) => beEmailMessageGetMessageLazyDetails(IdMessage))

  const smsCalls = steps
    .filter(
      ({ IdMessage, MessageType }) =>
        IdMessage > 0 && MessageType === WORKFLOW_MESSAGE_TYPE_SMS
    )
    .map(({ IdMessage }) => beSmsMessageGetSMSDetails(IdMessage))

  const emails = await Promise.all(emailCalls)
  const sms = await Promise.all(smsCalls)

  return {
    workflowEmails: emails.reduce((acc, message) => {
      acc[message.Id] = message.Subject
      return acc
    }, {}),
    workflowSms: sms.reduce((acc, message) => {
      acc[message.Id] = message.Subject
      return acc
    }, {}),
    conditionsDescription: await getConditionsDescription(idWorkflow)
  }
}

export async function fetchEmailEntitiesThatUseMessage(idMessage) {
  const ret = await beMessApiGetEntitiesThatUseMessage(idMessage)
  return ret
}

export async function fetchSmsEntitiesThatUseMessage(idMessage) {
  const ret = await beSmsMessageGetEntitiesThatUseMessage(idMessage)
  return ret
}

export async function copyMessage(idMessage, notes) {
  const result = await beMessApiCopyMessage(idMessage, notes)

  return result
}

export async function copySmsMessage(idMessage, notes) {
  const result = await beSmsMessageCopyMessage(idMessage, notes, '', '')

  return result
}

export async function fetchEmailStats(ids) {
  const hasStast = evalCondition('uo:STAT')
  const idList = storeGet(STORE_KEY_ID_LIST)
  const types = ['EI', 'AUI', 'CU', 'RIT']

  const calls = ids.map((idMessage) =>
    statisticsGetMessageTotalCounters(idList, idMessage, types)
  )

  const stats = await Promise.all(calls)

  const { sent, opens, clicks, deliv } = stats.reduce(
    (
      { sent, opens, clicks, deliv },
      {
        Counters: {
          TotalCounters: { EI, RIT, AUI, CU }
        }
      }
    ) => ({
      sent: sent + EI,
      opens: opens + AUI,
      clicks: clicks + CU,
      deliv: deliv + (EI - RIT)
    }),
    {
      sent: 0,
      opens: 0,
      clicks: 0,
      deliv: 0
    }
  )

  return {
    show: ids.length > 0,
    msgCount: ids.length,
    idMessage: ids.length > 0 ? ids[0] : 0,
    hasStast,
    sent,
    opens,
    clicks,
    pctOpens: deliv > 0 ? (100 * opens) / deliv : 0,
    pctClicks: deliv > 0 ? (100 * clicks) / deliv : 0
  }
}

export async function fetchSmsStats(ids) {
  const sentCalls = ids.map((id) => beSmsServicesCountMessageSent(id))
  const delivCalls = ids.map((id) => beSmsServicesCountMessageDeliveries(id))
  const clicksCalls = ids.map((id) => beSmsServicesCountMessageClicks(id))

  const [sentResp, delivResp, clicksResp] = await Promise.all([
    Promise.all(sentCalls),
    Promise.all(delivCalls),
    Promise.all(clicksCalls)
  ])

  const sent = sentResp.reduce((acc, { Data }) => acc + Data, 0)
  const delivs = delivResp.reduce((acc, { Data }) => acc + Data, 0)
  const clicks = clicksResp.reduce((acc, { Data }) => acc + Data, 0)

  return {
    show: ids.length > 0,
    ids,
    sent,
    delivs,
    clicks,
    pctDelivs: sent > 0 ? (100 * delivs) / sent : 0,
    pctClicks: sent > 0 ? (100 * clicks) / sent : 0
  }
}

export async function getFilterDetails(id) {
  const result = await beFiltersGetFilter(id)
  return result
}

export async function getGroupsDetails() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchType: GROUPS_SEARCH_TYPE_CONTAINS
  })

  return Items.map(({ Id, Name }) => ({
    label: `${Id} - ${Name}`,
    value: Id
  }))
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden,
      types: getAllAvailableFilterTypes()
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function getConditionsDescription(idWorkflow, showLink = false) {
  const data = {
    ConditionsOption: {
      ShowLink: showLink,
      LinkPlaceholders: {
        Begin: '<extlink>',
        End: '</extlink>'
      }
    }
  }
  const result = idWorkflow
    ? await beAutomatioApiGetConditionsdescription(idWorkflow, data)
    : {}
  return result
}

export const loadingUpdater = (loading) => (prev) => ({ ...prev, loading })
